import React, { useCallback, useImperativeHandle, useRef, useState } from "react";
import { isEqual, isFunction } from "@util/utils";
import SendSmsDialog from "@icoach/components/dialog/SendSmsDialog";
import { AddInvalidDialog, AddTemporaryDialog, DeleteNonMemberDialog, TemporariesDeleteDialog, NoMemberContactDialog, ProspectImportDialog } from "@icoach/nonMember/dialog/";

const NONMEMBERSMSDIALOG = "NONMEMBER_SMS_DIALOG";
const NONMEMBERADDINVALIDDIALOG = "NONMEMBER_ADD_INVALID_DIALOG";
const NONMEMBERADDTEMPORARYDIALOG = "NONMEMBER_ADD_TEMPORARY_DIALOG";
const NONMEMBERDELETENONMEMBERDIALOG = "NONMEMBER_DELETE_NONMEMBER_DIALOG";
const NONMEMBERDELETETEMPORARIESDIALOG = "NONMEMBER_DELETE_TEMPORARIES_DIALOG";
const NOMEMBERCONTACTDIALOG = "NOMEMBER_CONTACT_DIALOG";
const NONMEMBERPROSPECTIMPORTDIALOG = "NONMEMBER_PROSPECT_IMPORT_DIALOG";

const NonMemberDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState("");
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);
	const smsTemporaryRef = useRef(false);

	const handleDialogClose = useCallback(
		() => {
			setOpenDialog(null);
			setSourceData(null);
			refreshRef.current = null;
			smsTemporaryRef.current = false;
		},
		// eslint-disable-next-line
		[]
	);

	const doRefresh = (...arg) => {
		console.log(refreshRef.current);
		if (isFunction(refreshRef.current)) {
			const refreshFn = refreshRef.current;
			setTimeout(() => refreshFn(...arg), 5);
		}
	};

	useImperativeHandle(
		ref,
		() => ({
			openNonMemberSmsDialog: (targetData, refreshFn, isTemporaries = false) => {
				refreshRef.current = refreshFn;
				smsTemporaryRef.current = isTemporaries;
				setSourceData(targetData);
				setOpenDialog(NONMEMBERSMSDIALOG);
			},
			openNonMemberAddTemporary: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(NONMEMBERADDTEMPORARYDIALOG);
			},
			openNonMemberAddInvalid: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(NONMEMBERADDINVALIDDIALOG);
			},
			openNonMemberRemoveContractRecord: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(NONMEMBERDELETENONMEMBERDIALOG);
			},
			openNonMemberTemporaryDeleteRecord: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(NONMEMBERDELETETEMPORARIESDIALOG);
			},
			openNonMemberNoMemberContact: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(NOMEMBERCONTACTDIALOG);
			},
			openProspectImportDialog: (refreshFn) => {
				refreshRef.current = refreshFn;
				setOpenDialog(NONMEMBERPROSPECTIMPORTDIALOG);
			},
			// 關閉彈窗
			closeDialog: () => {
				handleDialogClose();
			},
		}),
		// eslint-disable-next-line
		[]
	);

	return (
		<React.Fragment>
			<SendSmsDialog open={isEqual(openDialog, NONMEMBERSMSDIALOG)} onClose={handleDialogClose} refresh={doRefresh} isTemporaries={smsTemporaryRef.current} sourceData={sourceData} />
			<AddTemporaryDialog open={isEqual(openDialog, NONMEMBERADDTEMPORARYDIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<AddInvalidDialog open={isEqual(openDialog, NONMEMBERADDINVALIDDIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<NoMemberContactDialog open={isEqual(openDialog, NOMEMBERCONTACTDIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<DeleteNonMemberDialog open={isEqual(openDialog, NONMEMBERDELETENONMEMBERDIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<TemporariesDeleteDialog open={isEqual(openDialog, NONMEMBERDELETETEMPORARIESDIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<ProspectImportDialog open={isEqual(openDialog, NONMEMBERPROSPECTIMPORTDIALOG)} onClose={handleDialogClose} refresh={doRefresh} />
		</React.Fragment>
	);
});

export default NonMemberDialogBox;
